module.exports = __webpack_public_path__ + "static/media/s3.7485bec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/s3.png
// module id = 13
// module chunks = 0